import { useState, useEffect, FC } from 'react';

import { Button } from '@livechat/design-system-react-components';
import Cookies from 'js-cookie';

import Config from 'Config';
import { CustomLink } from 'components/link/Link';
import { fetchProducts } from 'hooks/use-products';
import { useSharedStore } from 'stores/shared-store';
import Location from 'services/Location';
import { shouldHideSignup } from 'helpers/should-hide-signup';

export const NewAccount: FC = () => {
  const [skipSelectTrial, setSkipSelectTrial] = useState(false);
  const cookieProduct = Cookies.get('product');

  const checkIfShouldSkipSelectTrial = async () => {
    const clientId = Location.getUrlParam('client_id');
    let isKnownClientId = true;

    if (clientId) {
      try {
        const products = await fetchProducts();

        isKnownClientId =
          products.some((product) => product.client_id === clientId) ||
          clientId === Config.default_client_id ||
          clientId === import.meta.env.VITE_APP_CLIENT_ID;
      } finally {
        if (!isKnownClientId || cookieProduct) {
          setSkipSelectTrial(true);
        }
      }
    }
  };

  useEffect(() => {
    checkIfShouldSkipSelectTrial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateAccountClick = () => {
    if (!Location.isInLoginButtonPopup()) {
      return;
    }

    const createAccountButtonAction = Location.getUrlParam('create_account_button_action');

    switch (createAccountButtonAction) {
      case 'close-popup':
        Location.closePopupWindow();
        break;
      default:
    }
  };

  const defaultParams = {
    source_id: 'create_account_link',
    source_url: window.location.origin,
    source_type: 'accounts',
  };

  const sharedStore = useSharedStore();
  sharedStore.addMissing(defaultParams);
  const sharedStoreParams = sharedStore.toObject();
  const queryString = Object.keys(sharedStoreParams)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(sharedStoreParams[key].toString())}`
    )
    .join('&');

  if (shouldHideSignup()) {
    return null;
  }

  return (
    <CustomLink
      to={skipSelectTrial ? '/signup' : '/select-trial'}
      onClick={handleCreateAccountClick}
      qs={queryString}
      dataTestId="new-account-cutom-link"
    >
      <Button kind="secondary" size="medium" data-testid="new-account-button">
        Sign up free
      </Button>
    </CustomLink>
  );
};
